export default {
  title: {
    id: 'profile_page_legal_documents_tab_title',
    defaultMessage: 'Legal documents',
  },
  toDoLabel: {
    id: 'profile_page_legal_documents_tab_do_do_label',
    defaultMessage: 'To do',
  },
  identityCard: {
    id: 'profile_page_legal_documents_tab_identity_card',
    defaultMessage: 'This can be your non-expired ID card or passport.',
  },
  KBIS: {
    id: 'profile_page_legal_documents_tab_kbis',
    defaultMessage: 'This document must be less than 3 months old.',
  },
}
